import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

import {
  UploadedReceipt,
  FINAL_STATUSES,
} from '../../../types';
import { getUploadedReceiptById } from '../../BulkUploadPage/apis/uploadedReceiptApi';

const RECEIPT_POLL_INTERVAL = 5000;

/**
 * Fetches a single UploadedReceipt by ID with polling while in a non-final status.
 */
export const useReceiptQuery = (receiptId: string | null | undefined) => {
  const { getAccessTokenSilently } = useAuth0();

  const { data: receipt, isLoading: loading, error } = useQuery({
    queryKey: ['uploaded-receipt', receiptId],
    queryFn: async () => {
      if (!receiptId) return null;
      const token = await getAccessTokenSilently();
      return getUploadedReceiptById(receiptId, token);
    },
    enabled: !!receiptId,
    refetchInterval: query => {
      const data = query.state.data;
      if (!data) return RECEIPT_POLL_INTERVAL;
      if (FINAL_STATUSES.includes(data.status)) return false;
      return RECEIPT_POLL_INTERVAL;
    },
    refetchIntervalInBackground: false,
    staleTime: 0,
    gcTime: 60 * 1000,
  });

  return {
    receipt: receipt as UploadedReceipt | null | undefined,
    loading,
    error: error?.message || null,
  };
};
